<template>
  <default-layout>
     <v-layout wrap>
         <v-flex xs12>
             <editor-menu-bar></editor-menu-bar>
         </v-flex>

         <v-flex xs12 class="pt-5">
            <v-card class="elevation-12">
              <v-toolbar dark color="blue darken-1">
                <v-toolbar-title>Create Editor Account</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-container grid-list-md mx-1>
                    <v-layout wrap>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('firstName')"
                          data-vv-name="firstName"
                          v-model="firstName"
                          label="First Name"
                          type="text"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('lastName')"
                          data-vv-name="lastName"
                          v-model="lastName"
                          label="Last Name"
                          type="text"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-autocomplete
                          v-validate="'required'"
                          :error-messages="errors.collect('countryCode')"
                          data-vv-name="countryCode"
                          :items="countryCodes"
                          v-model="countryCode"
                          label="Country Code"
                          single-line
                          item-text="text"
                          item-value="text"
                          required
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('phone')"
                          data-vv-name="phone"
                          v-model="phone"
                          label="Phone Number"
                          type="text"
                        ></v-text-field>
                        <span style="color: red">{{phone_msg}}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field v-model="email" label="Email Address " type="text"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('password')"
                          data-vv-name="password"
                          v-model="password"
                          label="Password"
                          type="password"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('confirmPassword')"
                          data-vv-name="confirmPassword"
                          v-model="confirmPassword"
                          label="Confirm Password"
                          type="password"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <span style="color: red">{{err_msg}}</span>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-btn color="blue darken-1" @click="save" dark>Submit</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
         </v-flex>
     </v-layout>
  </default-layout>
</template>
<script>
import EditorMenuBar from '../_components/editor_menu.vue'
import { countryCodes } from "@/common/methods.js";
export default {
  name: 'EditorCreatePage',
  components: {
    EditorMenuBar
  },
  data () {
    return {
      expertColor: "white",
      toolbarColor: null,
      userAccount: null,
      accountType: null,
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      password: null,
      confirmPassword: null,
      role: null,
      err_msg: null,
      countryCodes: countryCodes(),
      phone_msg: null,
      countryCode: null
    };
  },
  methods: {
    navigateHome() {
      window.location = this.webUrl;
    },
    validMail(mail) {
      return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(
        mail
      );
    },
    save() {
      // validation
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          // pass check
          if(this.phone.startsWith('0')) {
            this.phone_msg = "If your Country Code is correct, do not start with ‘0’";
          } else if(!/^[0-9]+$/.test(this.phone)) {
            this.phone_msg = "Phone no should be Numerals only...";
          } else if (this.password !== this.confirmPassword) {
            this.phone_msg = null;
            this.err_msg = "Passwords Don't match!";
          } else {
            // test mail
            if (this.email !== null) {
              const mailTest = this.validMail(this.email);
              // check mail
              if (mailTest == false) {
                this.$refs.snackbar.show("Please put a correct email address!", "red");
              } else {
                // save
                const data = {
                  firstName: this.firstName,
                  lastName: this.lastName,
                  phone: this.phone,
                  email: this.email,
                  password: this.password,
                  accountType: 'editor',
                  role: 'editor',
                  editor: true,
                  countryCode: this.countryCode
                };

                this.loading = true;
                const self = this;
                const res = this.$store
                  .dispatch("post", { url: "/user/register", data })
                  .then(res => {
                    self.loading = false;
                    if (res.state == true) {
                      this.$router.push(`/editors`);
                    } else {
                      this.err_msg = res.err;
                    }
                  })
                  .finally(() => {});
              }
            } else {
              // save
              const data = {
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                email: this.email,
                password: this.password,
                accountType: 'editor',
                role: 'editor',
                editor: true,
                countryCode: this.countryCode
              };

              this.loading = true;
              const self = this;
              const res = this.$store
                .dispatch("post", { url: "/user/register", data })
                .then(res => {
                  self.loading = false;
                  if (res.state == true) {
                    localStorage.setItem("subscription", "noSubs");
                    localStorage.setItem("token", res.token);
                    self.$store.commit("setUser", res.user);
                    this.$router.push(`/editors`);
                  } else {
                    this.err_msg = res.err;
                  }
                })
                .finally(() => {});
              // end of save
            }

            // end of mail test

            // close pass check
          }
        }
      });
      //end of validation
    }
  },
  created () {
    this.$store.dispatch("get", "/user/all/editors").then(res => {
      this.editors = res.editors;
    });
  }
}
</script>
